import React from 'react';
import Header from '@ssg/common/Components/Header';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import CollectionItemsOverview from './CollectionItems/CollectionItemsOverview';
import ScreeningPositionTextsOverview from './ScreeningPositionTexts/ScreeningPositionTextsOverview';
import DebitorScalepointSetup from './Debitor/DebitorScalepointSetup';
import { useFlag } from '@unleash/proxy-client-react';
import { FeatureFlagEnums } from '@ssg/common/FeatureFlagEnums';

const tabs: string[] = ['general.collectionItemsOverviewTitle', 'screening.screeningPositionTexts', 'debitor.delayScalepointConnection'];

const GeneralTabs: React.FC = (): React.ReactElement => {
	const { t } = useTranslation();
	const [activeTab, setActiveTab] = React.useState<string>(tabs[0]);
	const debitorScalepointDelayFlag = useFlag(FeatureFlagEnums.DEBITOR_SCALEPOINT_DELAY);

	return (
		<div>
			<Header title="general.overviewTitle">
				<div className="flex">
					{tabs
						.filter(t => t !== 'debitor.delayScalepointConnection' || debitorScalepointDelayFlag)
						.map((title, i) => {
							return (
								<div className="mr-3 mt-1" key={i}>
									<button
										type="button"
										onClick={() => setActiveTab(title)}
										className={classNames('text-blue focus:outline-none', {
											'border-blue border-b-2': title === activeTab,
										})}
									>
										{t(title)}
									</button>
								</div>
							);
						})}
				</div>
			</Header>

			<div className="mx-14 bg-white p-4 pb-1">
				{activeTab === 'general.collectionItemsOverviewTitle' && <CollectionItemsOverview />}
				{activeTab === 'screening.screeningPositionTexts' && <ScreeningPositionTextsOverview />}
				{activeTab === 'debitor.delayScalepointConnection' && <DebitorScalepointSetup />}
			</div>
		</div>
	);
};

export default GeneralTabs;

